import { InjectionKey } from 'vue';
import { Language } from '@/common/domain/Language';

export const stafferLanguageRepositoryKey: InjectionKey<StafferLanguageRepository> = Symbol();

export interface StafferLanguageRepository {
  getCurrentLanguage(): Language;
  storeLanguage(locale: Language): void;
}
